import axios from 'axios';

export const URL = "https://app.pesatrack.iolabz.ug/api";
export const fileURL = "https://app.pesatrack.iolabz.ug/media";


// export const URL = "http://127.0.0.1:8000/api";
// export const fileURL = "http://127.0.0.1:8000/media"


const refreshToken = async () => {
	const refresh_token = sessionStorage.getItem('refresh_token');
	try {
	  const resp = await axios.post(`${URL}/accounts/token/refresh`, {"refresh": refresh_token});
	  return resp.data;
	} catch (e) {
    //handle the logout of the application
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('refresh_token');
    window.location.href = '/login';
   }
  };

const requester = axios.create({
  baseURL: URL,
  headers: {
    'Content-Type': 'application/json',
  }
})

requester.defaults.timeout = 120000;

requester.interceptors.request.use(
  async function (config) {
    const access_token = sessionStorage.getItem('access_token');
    const token = access_token

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    config.credentials = "same-origin";

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

requester.interceptors.response.use(
  (response) => {
    return response;
  },
  async error => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true
      const res = await refreshToken();

      const access_token = res.access;
      sessionStorage.setItem('access_token', access_token)

      requester.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;
      return requester(originalRequest);
    }
    return Promise.reject(error);
  }
);

export {requester};
    